// removed by extract-text-webpack-plugin
module.exports = {"createschool-modal":"createschool-modal","price-on-createschool-modal":"price-on-createschool-modal","school-name":"school-name","pull-left":"pull-left","school-success-icon":"school-success-icon","pull-right":"pull-right","age":"age"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/CreateSchool/Modal.scss
// module id = tLSZ
// module chunks = 0